import { Component, OnInit } from '@angular/core';
import { Data, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Breadcrumb } from './breadcrumb.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [CommonModule]
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs: Breadcrumb[];

  constructor(private readonly router: Router, private readonly activatedRoute: ActivatedRoute) {
    this.breadcrumbs = this._buildBreadcrumbs(this.activatedRoute.root);
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this._buildBreadcrumbs(this.activatedRoute.root);
      });
  }

  private _buildBreadcrumbs(
    activatedRoute: ActivatedRoute,
    url = ''
  ): Breadcrumb[] {
    const children: ActivatedRoute[] = activatedRoute.children;

    if (children.length == 0) { // NOSONAR
      return [];
    }

    let breadcrumbs: Breadcrumb[] = [];

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join('/');
      if (routeURL != '') { // NOSONAR
        url += `/${routeURL}`;
      }

      const routeData: Data = child.snapshot.data;
      if (routeData['breadcrumb']) {
        breadcrumbs.push({ label: routeData['breadcrumb'], url: url });
      } else if (routeData['apiData'] && routeData['apiData'].breadcrumb) {
        breadcrumbs.push({
          label: routeData['apiData'].breadcrumb,
          url: url,
        });
      } else if (routeURL != '' && routeData['breadcrumb'] != '') { // NOSONAR
        breadcrumbs.push({
          label: routeURL,
          url: url,
        });
      }
      breadcrumbs = breadcrumbs.concat(this._buildBreadcrumbs(child, url));
    }

    return breadcrumbs;
  }
}
